var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('ZuiHeader'),_vm._v(" "),_c('SubPageTemplate',{attrs:{"page-title":"精彩体验","dynamically-tab":"","pid":_vm.pid,"type":"experience","pageNav":false}}),_vm._v(" "),_c('ZuiFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92f5e33e","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/list.vue
// module id = 1452
// module chunks = 0